<template>
  <div class="step">
    <div class="left">
      <div class="left-form">
        <el-form :model="context" :rules="rulesTwoOne" ref="stepTwo">

          <el-form-item label prop="user_name">
            <div class="left-form_item">
              <div class="left-form_item-label">
                Логин
              </div>
              <div class="left-form_item-input">
                <el-input placeholder="Никнейм" v-model="context.user_name"></el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item label prop="url">
            <div class="left-form_item">
              <div class="left-form_item-label long-label">
                Короткая ссылка для вставки на ваш сайт
                <br/>
                <a style="color: gray; margin-bottom: 10px; font-size: 12px" target="_blank" :href="'https://croinc.ru/'+context.url"
                   disabled="">https://croinc.ru/{{context.url }}</a>
              </div>
              <div class="left-form_item-input">
                <el-input placeholder="Короткая ссылка для вставки на ваш сайт" v-model="context.url"></el-input>
              </div>
            </div>
          </el-form-item>

          <el-form-item label prop="pass">
            <div class="left-form_item">
              <div class="left-form_item-label">Пароль</div>
              <div class="left-form_item-input">
                <el-input placeholder="Пароль" v-model="context.pass" show-password auto-complete="new-password"></el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item label prop="passAgain">
            <div class="left-form_item">
              <div class="left-form_item-label">Подтвердите пароль</div>
              <div class="left-form_item-input">
                <el-input
                    placeholder="Подтвердите пароль"
                    v-model="context.passAgain"
                    show-password
                ></el-input>
              </div>
            </div>
          </el-form-item>


        </el-form>
        <div class="left-form-buttons">
          <div
              class="left-form-buttons_button white"
              @click="goToPrevForm"
          >Назад
          </div>
          <div
              class="left-form-buttons_button black"
              @click="submitForm('stepTwo')"
          >Далее
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FormHeader from './FormHeader';
  import validateMixin from './common';
  import api from './../api';

  export default {
    name: 'StepTwoTypeTwo',
    components: {
      FormHeader
    },

    props: {
      context: {required: true}
    },

    mixins: [validateMixin],
    data() {

        let validatePass = (rule, value, callback) => {
            const regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/
            if (!regex.test(value)) callback(new Error(`
            Заданный пароль не соответствует требованиям:
              Минимальная длина пароля восемь символов,
              Содержать минимум одну букву,
              Содержать минимум одну цифру.
            `));
            if (value.trim() === '') {
                callback(new Error('Необходимо заполнить поле Пароль'));
            } else {
                callback();
            }
        };
        let validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('Необходимо заполнить поле Подтвердите пароль'));
            } else if (value !== this.context.pass) {
                callback(new Error('Пароли должны совпадать'));
            } else {
                callback();
            }
        };

      return {
        imageURL: '',
        image: '',
        path: '',
        companyTemplates: [],
        rulesTwoOne: {
          user_name: [
              {required: true, message: 'Необходимо заполнить поле логин', trigger: 'blur'},
              {validator: this.validateUsername, trigger: 'blur'}
              ],
          url: [
              {
                required: true,
                message: 'Необходимо заполнить поле URL-адрес компании',
                trigger: 'blur'
              },
              {
                min: 0,
                max: 120,
                message: 'Длина названия не может превыщать 120 символов',
                trigger: 'blur'
              }, {validator: this.validateSlug, trigger: 'blur'}
            ],
            pass: [{validator: validatePass, trigger: 'blur'}],
            passAgain: [{validator: validatePass2, trigger: 'blur'}]
        }
      };
    },

    methods: {
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
            if (!valid) return false;
            this.$emit('onSubmit');
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      goToPrevForm() {
        this.$emit('onNavToPrevForm');
      }
    }
  };
</script>
<style lang="sass">
  .registration-content
    display: flex
    align-items: center
</style>


